// extracted by mini-css-extract-plugin
export default {"main":"Queue_main__5kz2J","active":"Queue_active__1rc4h","limit":"Queue_limit__Qfqm2","length":"Queue_length__NHYqP"};